import _ from "lodash"

import { vsNgFormlyType as autoNumericFormlyType  } from "../types/autoNumeric"

var helpers = {
  simpleStringField: simpleStringField,
  simpleDateField: simpleTypeGenerator("datepicker"),
  simpleDateTimeField: simpleTypeGenerator("datetimepicker"),
  simpleBoolField: simpleTypeGenerator("checkbox"),
  simpleNumberField: numberField,
  simplePercentageField: percentageField,
  simpleCurrencyField: currencyField,
  autoNumericCurrencyField,
  simpleReadonlyField: simpleReadonlyField,
  textAreaField: textAreaField,
  columnLayout: columnLayout,
  headerField: headerField,
}

function headerField(config) {
  return {
    key: config.key,
    type: "header",
    templateOptions: {
      headerText: config.headerText,
    },
    model: {},
  }
}

function simpleStringField(config) {
  const field = simpleTypeGenerator("input")(config)
  field.templateOptions.maxlength = config.maxlength
  field.templateOptions.minlength = config.minlength
  return field
}

function simpleReadonlyField(config) {
  const readonlyField = simpleTypeGenerator("readonly")(config)
  readonlyField.formatters = config.formatters
  return readonlyField
}

function textAreaField(config) {
  var simpleGenerator = simpleTypeGenerator("textarea")

  var field = simpleGenerator(config)
  field.templateOptions.rows = config.rows || 5

  return field
}

function currencyField(config) {
  var numberType = numberField(config)

  numberType.templateOptions.addonLeft = {
    class: "fa fa-usd",
  }

  return numberType
}

function autoNumericCurrencyField(config) {
  var numberType = simpleTypeGenerator(autoNumericFormlyType)(config)  

  numberType.templateOptions.minimumValue = config.min
  numberType.templateOptions.maximumValue = config.max
  numberType.templateOptions.decimalPlaces = config.decimalPlaces || 2
  numberType.templateOptions.step = config.step
  numberType.templateOptions.addonLeft = {
    class: "fa fa-usd",
  }

  return numberType
}

function percentageField(config) {
  var numberType = numberField(config)

  numberType.templateOptions.addonRight = {
    class: "fa fa-percent",
  }

  return numberType
}

function numberField(config) {
  var typeConfig = simpleTypeGenerator("input")(config)
  var templateOptions = typeConfig.templateOptions

  templateOptions.type = "number"
  templateOptions.min = config.min
  templateOptions.max = config.max
  templateOptions.step = config.step
  // typeConfig.formatters = [formatCurrency]
  // typeConfig.parsers = [convertToNumber]
  // templateOptions.onKeyup = async function (model, options, _this) {
  //   if (model !== undefined) {
  //     _this.model[options.key] = 1
  //     _this.model[options.key] = formatCurrency(model)

  //     await new Promise((resolve) => setTimeout(resolve, 1))
  //     _this.model[options.key] = convertToNumber(_this.model[options.key])
  //   }
  //}
  return typeConfig
}

// function convertToNumber(value) {
//   if (value === undefined) {
//     return value
//   }

//   value = value.replace(/,/g, "")

//   return value
// }
// function formatNumber(value) {
//   return value.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
// }

// function formatCurrency(input) {
//   if (input === undefined) {
//     return
//   }
//   var inputVal = input.toString()
//   if (inputVal === "") {
//     return
//   }
//   if (inputVal.indexOf(".") >= 0) {
//     var decimalPos = inputVal.indexOf(".")
//     var leftSide = inputVal.substring(0, decimalPos)
//     var rightSide = inputVal.substring(decimalPos)
//     leftSide = formatNumber(leftSide)
//     rightSide = formatNumber(rightSide)
//     rightSide = rightSide.substring(0, 2)
//     inputVal = leftSide + "." + rightSide
//   } else {
//     inputVal = formatNumber(inputVal)
//   }
//   return inputVal
// }

function simpleTypeGenerator(type) {
  return function (config) {
    var field = {
      key: config.key,
      className: config.className,
      name: config.name || config.key,
      templateOptions: {
        label: config.label || config.key,
        required: !!config.required,
        readonly: config.readonly,
        disabled: config.disabled,
      },
      model: config.model,
      defaultValue: config.defaultValue,
      expressionProperties: config.expressionProperties,
      hideExpression: config.hideExpression,
      watcher: config.watcher,
    }

    field.type = type
    return field
  }
}

function columnLayout(fieldDefinitions, columns, noRow) {
  var totalColumns = 12
  var columnSpan = totalColumns / columns
  var chunked = _.chunk(fieldDefinitions, columns)

  var className = "col-xs-" + columnSpan.toString()

  _.forEach(fieldDefinitions, function (fieldDefinition) {
    fieldDefinition.className = fieldDefinition.className
      ? `${fieldDefinition.className} ${className}`
      : className
  })

  return _.map(chunked, function (chunk) {
    return {
      className: noRow ? "" : "row",
      fieldGroup: chunk,
    }
  })
}

export default helpers
